
import { IonApp, IonContent, IonLoading, IonSplitPane } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import '../theme/variables.css';
import { useEffect, useState } from 'react';
import { _SMALL_SCREEN_WIDTH, _cachedLocalAutoL2image, _clipboardCards, _debugMode, _dict, _l2audio, _l2color, _l2image, _l2visibility, _lang, _nodes, _previousPath, _syncTimer, _topSentences, _updateAppTimer, _userEmail, _userUniqueId } from '../components/constants';

import Menu from '../components/Menu';

import Routing from '../components/Routing';
import { useGlobalStore } from '../components/stateManagement/globalZustand';
import { useUserStore } from '../components/stateManagement/userZustand';
import { useTreeStore } from '../components/stateManagement/treeZustand';
import { useUIStore } from '../components/stateManagement/UIZustand';
import { useHistory } from 'react-router';
import { signInAnonymously } from 'firebase/auth';
import { auth } from '../components/Auth';



const App: React.FC = () => {

  //REF-1

  const { hasLoggedIn, isUserStoreInitialized, userEmail, doLogin } = useUserStore();
  const { isTreeStoreInitialized } = useTreeStore();
  const { showLoading, setShowLoading, lang,
    isGlobalStoreInitialized } = useGlobalStore();
  const { isArtistMode } = useUIStore();

  const [stop, setStop] = useState(true);
  const history = useHistory();
  /*const {
    isTourDone,
    setStepIndex,
    stepIndex
  } = useTourStore();

  const { isMenuOpen } = useUIStore();*/


  useEffect(() => {
    if (isGlobalStoreInitialized === true && isTreeStoreInitialized === true && isGlobalStoreInitialized === true) {
      if (userEmail === "" || userEmail === undefined || userEmail === null) {
        signInAnonymously(auth)
          .then(async (data) => {
            // Handle the successful anonymous login here.
            await doLogin(data.user.uid, undefined);
          })
          .catch((error) => {
            history.push("/login");
          });
      }
      setStop(false);
    }
  }, [isGlobalStoreInitialized,
    isUserStoreInitialized,
    isTreeStoreInitialized,
    isGlobalStoreInitialized]);



  if (stop) { return <></> }



  return <IonApp>
    <IonSplitPane contentId="main" when="false">
      {hasLoggedIn && !isArtistMode && <Menu />}
      <IonContent id="main" fullscreen>
        <Routing />
        <IonLoading isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={_dict.loading[lang]}
        />
      </IonContent>
    </IonSplitPane>
  </IonApp>;
}

export default App;

